/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ContactsStats } from './ContactsStats.js';
import {
    ContactsStatsFromJSON,
    ContactsStatsFromJSONTyped,
    ContactsStatsToJSON,
} from './ContactsStats.js';

/**
 * 
 * @export
 * @interface GetContactsStatsResponse
 */
export interface GetContactsStatsResponse {
    /**
     * 
     * @type {ContactsStats}
     * @memberof GetContactsStatsResponse
     */
    data?: ContactsStats;
    /**
     * 
     * @type {number}
     * @memberof GetContactsStatsResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetContactsStatsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetContactsStatsResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetContactsStatsResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetContactsStatsResponse interface.
 */
export function instanceOfGetContactsStatsResponse(value: object): boolean {
    return true;
}

export function GetContactsStatsResponseFromJSON(json: any): GetContactsStatsResponse {
    return GetContactsStatsResponseFromJSONTyped(json, false);
}

export function GetContactsStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContactsStatsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ContactsStatsFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetContactsStatsResponseToJSON(value?: GetContactsStatsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ContactsStatsToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

